export enum DialogCommandName {
    CLOSE = `dialog.close`,
    OKAY = `dialog.okay`,
    CANCEL = `dialog.cancel`
}